module.exports = __webpack_public_path__ + "img/www.producthunt.com.7f6369a7.png";